<template>
   <div class="layout-page">
      <h1>Contact Us</h1>

      <div class="mart-12 instructions">
         Use the form below to send us a request. If you prefer you can contact the Marketing Department at 888-441-0770 or email us at
         <a :href="mktMail">{{ emailAddress }}</a>.
      </div>
      
      <form class="mart-24 container-fluid">
         <div class="form-group row">
            <label for="reqDate" class="col-sm-2 col-form-label">Request Date</label>
            <div class="col-sm-7">
               <input type="text" readonly class="form-control-plaintext" id="reqDate" v-model="when">
            </div>
         </div>
         <div class="form-group row">
            <label for="requester" class="col-sm-2 col-form-label">Requester</label>
            <div class="col-sm-7">
               <input type="text" readonly class="form-control-plaintext" id="requester" v-model="requester">
            </div>
         </div>
         <div class="form-group row">
            <label for="requesterNumber" class="col-sm-2 col-form-label">Requester Agent #</label>
            <div class="col-sm-7">
               <select class="form-control" id="requesterNumber" required v-model="requesterAgentNumber">
                  <option :value="null" disabled hidden>(Select Requester Agent #)</option>
                  <option v-for="agentNo in agentNumbers" :value="agentNo" :key="agentNo">{{ agentNo }}</option>
               </select>
            </div>
         </div>
         <div class="form-group row">
            <label for="recip" class="col-sm-2 col-form-label">Recipient</label>
            <div class="col-sm-7">
               <input type="text" readonly class="form-control-plaintext" id="recip"
                  value="This request will go to internal EasyAppoint administrators">
            </div>
         </div>
         <div class="form-group row">
            <label for="subjectCode" class="col-sm-2 col-form-label">Subject</label>
            <div class="col-sm-7">
               <select class="form-control" id="subjectCode" required v-model="subjectCode">
                  <option :value="null" disabled hidden>(Choose a Message Type)</option>
                  <option v-for="typ in svcRequestTypes" :value="typ.vleCode" :key="typ.vleCode">{{ typ.vleValue }}
                  </option>
               </select>
            </div>
         </div>

         <p>Enter the details of your request below and click the Send button:</p>

         <div class="row">
            <div class="col-sm-9">
               <textarea class="form-control" v-model="requestText" rows="6"></textarea>
            </div>
         </div>

         <div class="row mart-12">
            <div class="col-sm-9">
               <i class="fas fa-paperclip"></i>
               Attach a File<br />
               <p class="instructions">
                  Optionally, you can drag one document from your computer to the drop zone and it
                  will be uploaded along with your message. Due to file size contraints, please
                  send a separate message for each file you want to upload.
               </p>
            </div>
         </div>
         <div class="row">
            <div class="col-sm-9">
               <div id="drop-area">
                  <div v-for="(fyl, index) in droppedFiles" :key="index" class="drop-file">
                     <i class="fa fa-file-alt"></i>
                     {{ fyl.name }}
                     <span @click.prevent="deleteFile(fyl.name)"><i
                           class="fa fa-times font-smaller text-danger"></i></span>
                  </div>
                  <div v-if="droppedFiles.length == 0" class="drop-msg">
                     <i class="fi-interface-upload"></i>
                     DRAG a DOCUMENT HERE<br />
                     <input type="file" name="file" id="file" class="inputfile" @change="inputFileChanged" />
                     <label for="file">or [Click to Choose a File]</label>
                  </div>
               </div>
            </div>
         </div>

         <div class="form-group row mart-12">
            <div class="col-sm-9 text-right">
               <button type="button" class="btn ml-btn ml-bk-corp ml-white ml-h-black snc-btn" @click.prevent="send">
                  <i class="fas fa-spinner fa-spin" v-if="busy"></i>
                  <span v-else>
                     <i class="fas fa-paper-plane"></i>
                     SEND REQUEST
                  </span>
               </button>
            </div>
         </div>
         
      </form>

   </div>
</template>
   
<script>
import moment from 'moment'
import axios from 'axios'


export default {
   name: 'SvcRequest',
   data() {
      return {
         subjectCode: null,
         when: moment().format('MM/DD/YYYY LT'),
         requester: '',
         svcRequestTypes: [],
         busy: false,
         requestText: '',
         requesterAgentNumber: null,
         agentNumbers: [],
         mktMail: `mailto:${process.env.VUE_APP_MKT_EMAIL}`,
         emailAddress: process.env.VUE_APP_MKT_EMAIL,
         dropArea: null,
         droppedFiles: [],
         sending: false,
         uploadPercentage: 0,
         ismobile: false,
         maxDroppedFiles: 1,
         minDroppedFiles: 1,
         uploadingDocType: 0
      }
   },
   async mounted() {
      this.busy = true
      if (this.$route.params.typ) {
         this.subjectCode = this.$route.params.typ
      }
      await this.$agent.getList('SVC_REQST_TYP')
         .then((r) => {
            if (r && r.length > 0) {
               this.$set(this, 'svcRequestTypes', r)
            }
         })
         .catch((err) => {
            // log err
         })

      let usr = this.$store.getters.userClaims
      this.requester = `${usr.given_name} ${usr.family_name} (${this.$store.getters.appUser.userName})`
      this.busy = false
      await this.getRequesterAgentNumbers()

      //Handle attachment drag-n-drop
      this.initializeDragNDrop()
   },
   methods: {
      async send() {
         this.busy = true

         // validate input
         if (this.subjectCode == null || this.subjectCode == '') {
            this.$swal(
               "Subject?",
               "Choose the subject of your request from the dropdown list",
               "error"
            )
            this.busy = false
            return
         }
         if (this.requestText == null || this.requestText == '') {
            this.$swal(
               "Request?",
               "You must enter some text regarding what you would like help with into the big text box.",
               "error"
            )
            this.busy = false
            return
         }
         if (this.droppedFiles.length > this.maxDroppedFiles) {
            this.$swal(
               "Too Many Attachments",
               "You must select only 1 file to upload.",
               "error"
            )
            this.busy = false
            return;
         }

         let formData = this.getFormData()
         this.uploadPercentage = 0
         
         this.$swal({
            title: "Please Wait",
            html: "<i class='fas fa-2x fa-spinner fa-spin ml-corp'></i>",
            showConfirmButton: false
         })
         let token = await this.$auth.Token()
         axios.post(process.env.VUE_APP_BASE_API_URL + "corr/svcreq",
            formData,
            {
               headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': `Bearer ${token}`
               },
               onUploadProgress: function (progressEvent) {
                  this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
               }.bind(this)
            }
         ).then(r => {
            this.$swal.close()
            this.busy = false
            this.$swal(
               "Request Sent!",
               "Your service request was successfully sent.",
               "success"
            ).then(() => {
               // delete uploaded docs from dropzone
               this.droppedFiles = []
               this.$router.push({ name: 'home' })
            })
         })
         .catch(async (e) => {
            if ((e.status && e.status == 401) || (e.response && 401 === e.response.status)) { //UnAuthorized - kick'em out
               await this.$swal(
                  "Session Timeout",
                  "It looks like your session on the site has timed out. Please log in again to resume...",
                  "warning"
               )
               .then((result) => {
                  this.$auth.logout();
               })
               return
            }
            this.$swal.close()
            this.busy = false
            this.$swal(
               "System Error",
               "A system error caused your request to fail. Please try again later and contact support if this problem persists.",
               "error"
            )
         })

         // await this.$agent.sendRequest(payload)
         //    .then((r) => {
         //       this.$swal(
         //          "Request Sent!",
         //          "Your service request was successfully sent.",
         //          "success"
         //       )
         //       this.busy = false
         //       this.$router.push({ name: 'home' })
         //    })
         //    .catch((err) => {
         //       this.$swal(
         //          "Oops!",
         //          "A system error caused your request to fail. Please try again later and contact support if this problem persists.",
         //          "error"
         //       )
         //    })

         this.busy = false
      },
      getFormData() {
         // save request to database
         var uid = this.$store.getters.appUser.userId
         var when = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString()
         var role = this.$store.getters.appUser.userRoleCode

         let formData = new FormData()
         formData.append("files", this.droppedFiles[0]); //only the first
         formData.append("serviceRequestId", 0)
         formData.append("requestDt", when)
         formData.append("requester",this.requester)
         formData.append("requesterUserId", uid)
         formData.append("requesterTypeId", 0)
         formData.append("requesterNumber", this.requesterAgentNumber)
         formData.append("requestTypeId", 0)
         formData.append("createDt", when)
         formData.append("createdById", uid)
         formData.append("updateDt",when)
         formData.append("updatedById", uid)
         formData.append("isComplete", false)
         formData.append("requestText", this.requestText)
         formData.append("requestTypeCode", this.subjectCode)
         formData.append("requesterTypeCode", role == 'USRROLE_MD' ? 'RQTYP_MD' : 'RQTYP_AGT')
         return formData
      },
      async getRequesterAgentNumbers() {
         await this.$store.dispatch("getHierarchies")
         this.hierarchies = this.$store.getters.hierarchies
         if (this.hierarchies) {
            this.hierarchies.forEach((itm, index) => {
               if (!this.agentNumbers.includes(itm.agentNo)) {
                  this.agentNumbers.push(itm.agentNo)
               }
            })
         }
      },
      // Drag-N-Drop functions
      initializeDragNDrop() {
         this.dropArea = document.getElementById("drop-area");
         ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.preventDefaults, false)
         })

         this.dropArea.addEventListener("drop", this.handleDrop, false);
         ["dragenter", "dragover"].forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.highlight, false)
         });
         ["dragleave", "drop"].forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.unhighlight, false)
         })
      },
      highlight(e) {
         this.dropArea.classList.add("highlight")
      },
      unhighlight(e) {
         this.dropArea.classList.remove("highlight")
      },
      preventDefaults(e) {
         e.preventDefault()
         e.stopPropagation()
      },
      handleDrop(e) {
         // ---- Drag N Drop method of Adding Files
         this.handleFiles(e)
      },
      handleFileUpload() {
         // ---- Manual method of adding files (mobile)
         var file = this.$refs.inpfile.files[0]
         const low = file.name.toLowerCase()
         if (low.indexOf(".pdf") < 0) {
            this.$swal(
               "Invalid File",
               "The file you are uploading must be one of these types:<br />(PDF)",
               "error"
            )
            return
         }
         if (file.size > 2000000) {
            this.$swal(
               "Invalid File",
               "The file you are uploading is too big. It must be 2MB or smaller.",
               "error"
            )
            return
         }
         // Its good. Lets keep it
         this.droppedFiles.push(file)
      },
      handleFiles(ev) {
         // Use DataTransferItemList interface to access the file(s)
         for (var i = 0; i < ev.dataTransfer.items.length; i++) {
            // Validate the dropped file
            if (ev.dataTransfer.items[i].kind === "file") {
               var file = ev.dataTransfer.items[i].getAsFile()
               const low = file.name.toLowerCase()
               if (low.indexOf(".pdf") < 0) {
                  this.$swal(
                     "Invalid File",
                     "The file you are uploading must be one of these types:<br />(PDF)",
                     "error"
                  )
                  return
               }
               if (file.size > 2000000) {
                  this.$swal(
                     "Invalid File",
                     "The file you are uploading is too big. It must be 2MB or smaller.",
                     "error"
                  )
                  return
               }

               // Its good. Lets keep it
               this.droppedFiles.push(file)
            }
         }
      },
      inputFileChanged(ev) {
         let fileName = '';
         fileName = ev.target.value.split('\\').pop()
         let files = ev.target.files
         if (files.length < 1) {
            return
         }
         let file = files[0]
         const low = file.name.toLowerCase()
         if (low.indexOf(".pdf") < 0) {
            this.$swal(
               "Invalid File",
               "The file you are uploading must be one of these types:<br />(PDF)",
               "error"
            )
            return
         }
         if (file.size > 2000000) {
            this.$swal(
               "Invalid File",
               "The file you are uploading is too big. It must be 2MB or smaller.",
               "error"
            )
            return
         }

         // Its good. Lets keep it
         this.droppedFiles.push(file)
      },
      deleteFile(fyl) {
         let indx = 99;
         let df = [];
         for (var i = 0; i < this.droppedFiles.length; i++) {
            if (this.droppedFiles[i].name != fyl) {
               df.push(this.droppedFiles[i]);
            }
         }
         this.droppedFiles = df;
      },
      // End drag n drop methods

   }
}
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';

input[readonly] {
   border-bottom-width: 0px;
}

/* dragNdrop styles */
#drop-area {
   background-color: #eee;
   border: 1px dashed $corp-color;
   border-radius: 0;
   width: 100%;
   height: 100px;
   text-align: center;
   vertical-align: middle;
   font-size: 0.8em;
   padding-top: 24px;
}

.inputfile {
   width: 0.1px;
   height: 0.1px;
   opacity: 0;
   overflow: hidden;
   position: absolute;
   z-index: -1;
}

.inputfile+label {
   display: inline-block;
   cursor: pointer;
}

.inputfile:focus+label,
.inputfile+label:hover {
   color: $corp-color;
}

.drop-msg {
   font-family: corporate-s, sans-serif !important;
}

</style>